export default __webpack_public_path__ + "static/media/bendystav-o-nas.0d4a00e6.jpeg";